export default __webpack_public_path__ + "static/media/icon_custom-search.5e5ed293.svg";